export default __webpack_public_path__ + "static/media/My_Breakthrough_Lock.25678f06.jpg";